import axios from 'axios';
import { toast } from 'react-toastify';
const API = axios.create({
    baseURL: "https://api.eduexpose.in/api/v1"
    
});

// http://localhost:5555

// https://api.eduexpose.in/api/v1


API.interceptors.request.use(function (config:any) {
    const token = sessionStorage.getItem('token');
    const contentType = config.headers["Content-Type"];
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    if (contentType === "multipart/form-data") {
        // Set the Content-Type to multipart/form-data
        config.headers["Content-Type"] = "multipart/form-data";
      } else {
        config.headers["Content-Type"] = "application/json";
      }
    //   config.headers['Access-Control-Allow-Origin'] = '*';
    
    return config;
});

API.interceptors.response.use(
    (response:any) => {
        if (response.data.data) {
            return response.data;
        }
        else {
            return response.data ? response.data : {};
        }
    }, (error:any) => {
        if (error?.response?.status === 401) {
            window.location.href = '/';
            toast.error("Session expired");
        }
        return error.response && error.response.data ? error.response.data : {};
    }
);


export default API;
